const BASE_URL = 'remittance'
// REACT_APP_BASE_URL=https://sit-apig.jiomoney.com/jpbapig/

export const APIEndPoints = {
  appAuth: 'jpb/v1/app/authenticate',
  // getAgentInformation: 'jpb/v1/aepsAgent/getAgentUserInformation/',
  getAgentInformation: 'jpb/v5/agent/getAgentUserInformation',
  getAgentInformationV3: 'jpb/v3/agent/getAgentUserInformation/',
  consent: 'jpb/v1/aeps/customer/consent',
  generateOtp: 'jpb/v1/user/authenticate',
  authenticateOtp: 'jpb/v1/user/authenticate',
  getBalance: 'aeps/payouts',
  addAgentUserIdentity: 'jpb/v1/agent/agent-user/identity',
  getBankList: 'jpb/v1/aeps/common/banks',
  getBankIfscList: '/remittance/jpb/v2/crm/getBanksByOrder',
  getBankIfsc: '/remittance/jpb/v2/crm/getIFSCCode',
  userAuth: 'jpb/v1/user/authenticate',
  fetchTransactionDetail: 'jpb/v1/aeps/payouts/status',
  executeTransaction: 'jpb/v1/aeps/payouts/transaction',
  linkAadhaar: 'jpb/v1/customer/identity/linking',
  fetchTransactionHistory: 'jpb/v1/aeps/payouts/agenthistory',
  invalidateUserSession: 'jpb/v1/user/session/expire',
  invalidateAppSession: 'jpb/v1/app/session/expire',
  sendEvent: 'jpb/v1/aeps/common/event/add',
  getReceipt: 'jpb/v1/aeps/payouts/getReceipt',
  getUniqueDeviceSession: 'jpb/v1/aeps/common/agent/session',
  //DOMESTIC MONEY TRANS
  //---------------------------------------------------------------- api gateway url
  checkCustomerExist: 'jpb/v1/remittance/user/validate',
  createRemittanceUser: 'jpb/v1/remittance/user',
  fetchRemittanceUser: '/jpb/v1/remittance/user/fetch',
  validateBenifStatus: `${BASE_URL}/jpb/v1/ats/transaction/status`,
  getPincodeInfo: `${BASE_URL}/jpb/v1/crm/getPincode/`,
  dmrTransactions: `${BASE_URL}/jpb/v1/ats/transaction/history`,
  getDmtAvailableLimitApi: '/jpb/v2/productLimit/getCustomerLimit',
  dmtBeneLimit: "remittance/jpb/v1/crm/getCommonCodeByKey/DMT_BENE_ADD_LIMIT",
  deleteBenificiary: "remittance/beneficiary/delete",

  //----------------------------------------------------------------
  //BBPS BILL PAYMENT
  searchAgentBC: `/jpb/v1/dsp/agent/searchAgent`,
  getCategoryListV2BC: `/jpb/v1/dsp/pc/category/getCategoryListV2`,
  bbpsAgentOnboard: `/jpb/v1/dsp/agent/onboardAgent`,
  getFavoriteTransactionsBC: `/jpb/v1/dsp/billers/getFavoriteTransactionBC`,
  manageFavoriteTransactionsBC: `jpb/v1/dsp/order/manageFavTxns`,
  getProductList: `/jpb/v1/dsp/pc/product/getProductList`,
  fetchUser: `jpb/v1/user/fetch`,
  generateOtpUser: `jpb/v1/user/authenticate`,
  verifyOtpUser: `jpb/v1/user/authenticate`,
  registerUser: `jpb/v1/user/register`,
  getAuthenticatorList: `jpb/v1/dsp/pc/product/getAuthenticatorList`,
  billFetchAPI: `/jpb/v1/dsp/bill/billFetch`,
  createOrderAPI: `jpb/v2/dsp/order/create`,
  getOrderHistoryBC: `jpb/v2/dsp/order/getOrderHistory`,
  getBrowsePlanList: `/jpb/v1/dsp/pc/product/getBrowsePlanList`,
  getLRNMapping: `/jpb/v2/dsp/pc/product/getLRNMapping`,
  getCircleList: `/jpb/v1/dsp/pc/product/getCircleList`,
  // getCircleList: `/jpb/ebpp/api/v1/billers/getCircleList`,
  updatePaymentAPI: `/jpb/ebpp/api/v1/billers/getCircleList`,
  checkStatusAPI: `/jpb/ebpp/api/v1/billers/getCircleList`,
  BILLER_Logo_IMAGE_BASE_URL: `https://sit-apig.test.jiobank.in/jpb/v2/billers/image/`,

  //PAyment Gateway Integration APIs
  createIntentAPI: `/jpb/v1/payments/intent`,
  //----------------------------------------------------------------

  addNewBeneficiary: `${BASE_URL}/beneficiary/add`,
  // addNewBeneficiary: `http://10.162.6.163:9020/jpb/v1/beneficiary/add`,

  getAllBeneficiary: `${BASE_URL}/beneficiary/getByRemitterId`,
  // getAllBeneficiary: `http://10.162.6.163:9020/jpb/v1/beneficiary/getByRemitterId`,

  getBenificiaryByID: `${BASE_URL}/beneficiary/remitterId`,
  // getBenificiaryByID: `http://10.162.6.163:9020/beneficiary/remitterId`,

  getIfscCode: `${BASE_URL}/jpb/v1/crm/getIFSCCode`,
  // getIfscCode: `http://10.162.6.163:9022/jpb/v1/crm/getIFSCCode`,

  validateIfscCode: `${BASE_URL}/jpb/v1/crm/validateIFSC`,
  // validateIfscCode: `http://10.162.6.163:9022/jpb/v1/crm/validateIFSC`,

  validateBeneficiary: `${BASE_URL}/jpb/v1/ats/beneficiary/validate`,
  // validateBeneficiary: `http://10.162.6.163:9012/jpb/v1/ats/beneficiary/validate`,

  transferMoney: `${BASE_URL}/jpb/v1/ats/transaction`,
  // transferMoney: `http://10.162.6.163:9012/jpb/v1/ats/transaction`,

  convenienceFee: `${BASE_URL}/jpb/v1/merchant/convenienceFee`,
  // convenienceFee: 'http://10.162.6.163:9024/jpb/v1/merchant/convenienceFee',

  // getAgentBankDetails: `http://10.162.6.171:9017/jpb/v1/agent`,
  getAgentBankDetails: `${BASE_URL}/jpb/v1/account/getAccount`,

  // getOccupationData: `http://10.162.6.163:9022/jpb/v1/crm/getOccupation`,
  getOccupationData: `${BASE_URL}/jpb/v1/crm/getOccupation`,

  getValidateBeneficiaryChargeDetails: `${BASE_URL}/jpb/v1/crm/getCommonCodeByKey/VALIDATE_BENE`,
  // getValidateBeneficiaryChargeDetails: 'http://10.162.6.163:9022/jpb/v1/crm/getCommonCodeByKey/VALIDATE_BENE',

  // doesBeneficiaryWithSameAccountExist: 'http://10.162.6.163:9020/beneficiary/check',
  doesBeneficiaryWithSameAccountExist: `${BASE_URL}/beneficiary/check`,

  // REFUND FLOW CALL
  validateRefund: `${BASE_URL}/getVoucher`,
  //https://sit-apig.jiomoney.com/jpbapig/remittance/getVouchers
  getVouchers: `${BASE_URL}/getVouchers`,
  getVoucher: `${BASE_URL}/getVoucher`,
  redeemVoucher: `${BASE_URL}/jpb/v1/ats/voucher/redeem`,
  resendVoucher: `${BASE_URL}/resendVoucher`,
  fetchKycDetails: '/jpb/v1/bc/JIOKUA3/rest/kyc',
  // fetchKycDetails: '/mock/response/ekyc',

}

export const downloadReceipt_Test_url = 'https://www.africau.edu/images/default/sample.pdf'
